import React from 'react';

import { css } from '@emotion/react';
import { IonContent, IonPage } from '@ionic/react';
import { useGetNetworks } from '../../api/queries/getNetworks';
import { NetworkSelector } from '../../components/NetworkSelector';
import PageHeader from '../../components/PageHeader';

export const SelectNetworkPage: React.FC = () => {
  const { data } = useGetNetworks();
  return (
    <IonPage>
      <PageHeader title="Network Selector" />
      <IonContent>
        <div
          css={css({
            margin: 'auto',
            maxWidth: '40rem',
          })}
        >
          <NetworkSelector networks={data?.data.networks} />
        </div>
      </IonContent>
    </IonPage>
  );
};
